
export class NavMenuConfig {
    data = [];

    default_menu = 'management_team';

    constructor() {
        this.data = {

            management_team: {
                title: 'Management Team',
                menus: [
                    {
                        text: "Jobs",
                        sections: [
                            {path: "/management/jobs", text: "Job Overview"},
                            {path: "/management/jobs/view-new-jobs", text: "New Jobs"},
                            {path: "/management/jobs/view-completed-jobs", text: "Completed Jobs"},
                            {path: "/management/jobs/view-all-jobs", text: "All Jobs"},
                        ],
                    },
                    {
                        text: "Administration",
                        sections: [
                            {path: "/management/admin", text: "Admin Overview"},
                            {path: "/management/admin/view-new-enquiries", text: "New Enquiries"},
                            {path: "/management/admin/view-approved-enquiries", text: "Approved Enquiries"},
                            {path: "/management/admin/view-all-enquiries", text: "All Enquiries"},
                            {path: "/management/admin/enquiry-form", text: "Enquiry Form"},
                        ],
                    },
                    {
                        text: "Design",
                        sections: [
                            {path: "/management/design", text: "Design Overview"},
                            {path: "/management/design/new-jobs", text: "New Designs"},
                            {path: "/management/design/completed-jobs", text: "Completed Designs"},
                            {path: "/management/design/all-jobs", text: "All Designs"},
                        ],
                    },
                    {
                        text: "Printing",
                        sections: [
                            {path: "/management/print", text: "Printing Overview"},
                            {path: "/management/print/new-jobs", text: "Pending Printing Jobs"},
                            {path: "/management/print/completed-jobs", text: "Completed Printing Jobs"},
                            {path: "/management/print/all-jobs", text: "All Printing Jobs"},
                        ]
                    },
                    {
                        text: "Installation",
                        sections: [
                            {path: "/installation", text: "Hub"},
                            {path: "/installation/unassigned", text: "Unassigned Jobs"},
                            {path: "/installation/assigned", text: "Assigned Jobs"},
                            {path: "/installation/completed", text: "Completed Jobs"},
                            {path: "/installation/calendar", text: "Calendar"},
                        ]
                    },
                    {
                        text: "Employees",
                        sections: [
                            {path: "/management/employees", text: "Employee Overview"},
                        ]
                    },
                ]
            },

            /*
            
            TODO: when we have other views they should be implemented like this
            
            installation_team: {
                title: 'Installation Team',
                menus: [
                    { path: "/", text: "Hub" },
                    { path: "/", text: "Calendar" },
                    { path: "/", text: "Current Installation Jobs" },
                    { path: "/", text: "Completed Jobs" },
                ]
            },

            customer_service_team: {
                title:'Customer Service Team',
                menus: [
                    { path: "/", text: "Hub" },
                    { path: "/", text: "Customer List" },
                    { path: "/", text: "Customer Messages?" },
                ]
            },

            production_team: {
                title:'Production Team',
                menus: [
                    { path: "/", text: "Hub" },
                    { path: "/", text: "Current Printing Jobs" },
                    { path: "/", text: "Inventory" },
                    { path: "/", text: "Completed Jobs" },
                ]
            },

            design_team: {
                title:'Design Team',
                menus: [
                    { path: "/", text: "Hub" },
                    { path: "/", text: "In Progress Designs" },
                    { path: "/", text: "Amendments" },
                    { path: "/", text: "Confirmed Designs" },
                    { path: "/", text: "Completed Jobs" },
                ]
            },

            customer: {
                title:'Customer',
                menus: [
                    { path: "/", text: "Specifcation" },
                    { path: "/", text: "Design" },
                    { path: "/", text: "Production" },
                    { path: "/", text: "Installation" },
                    { path: "/", text: "Delivery" },
                ],

                nav_links:[
                    { path:"/", text:"My Jobs" },
                ]
            }*/
        };
    }


    getMenuType(path) {

        for (let menuType in this.data) {

            const menus = this.data[menuType].menus;

            for (let menuItem of menus) {
                if (typeof (menuItem['path']) != 'undefined') {
                    if (menuItem['path'] === path) {
                        return menuType;
                    }
                }
                if (typeof (menuItem.sections) != 'undefined') {
                    for (let link of menuItem.sections) {
                        if (link.path === path) {
                            return menuType;
                        }
                    }
                }
            }

            if (typeof (this.data[menuType].nav_links) != 'undefined') {
                for (let item of this.data[menuType].nav_links) {
                    if (item.path === path) {
                        return menuType;
                    }
                }
            }

        }
        return this.default_menu;
    }

    get(path) {
        const type = this.getMenuType(path);
        return this.data[type];
    }

}
